<template>
  <Modal
    class="my-modal withdrawal-modal top"
    v-model="visible"
    :title="title"
    :transfer="false"
    @on-visible-change="$refs.form.resetFields()"
    :footer-hide="true"
    :mask-closable="false"
    :closable="false"
    width="1100px"
  >
    <span class="tips">*请确认银行卡信息是否正确</span>
    <Form ref="form" :model="form" :label-width="115" class="page-form">
      <FormItem label="持卡人姓名">
        <Input v-model="form.userName" disabled />
      </FormItem>
      <FormItem label="证件类型">
        <Input value="身份证" disabled />
      </FormItem>
      <FormItem prop="idNo" label="证件号">
        <Input v-model="form.idNo" disabled placeholder="请输入" maxlength="30" />
      </FormItem>
      <FormItem prop="cardNo" label="银行卡号" :rules="$units.formRule.required('请输入银行卡号')">
        <Input v-model="form.cardNo" placeholder="请输入" @on-blur="changeCard" maxlength="30" />
      </FormItem>
      <FormItem prop="bankCode" label="开户行" :rules="$units.formRule.required('请选择开户行')">
        <Select v-model="form.bankCode" transfer filterable>
          <Option v-for="item in bankList" :value="item.value" :key="item.value">{{ item.txt }}</Option>
        </Select>
      </FormItem>
      <div class="two">
        <FormItem prop="mobile" label="银行预留手机号" :rules="$units.formRule.required('请添加手机号')">
          <Input v-model="form.mobile" disabled maxlength="20" />
        </FormItem>
        <Button type="primary" v-if="form.mobile" @click="$refs.changeMobile.open(form.mobile, form.cardNo)">变更手机号</Button>
        <Button type="primary" v-else @click="$refs.changeMobile.open('')">新增手机号</Button>
      </div>
      <FormItem prop="deliveryCompany" label="快递公司">
        <Input v-model="form.deliveryCompany" placeholder="如邮寄发票请填写，如顺丰快递" maxlength="20" />
      </FormItem>
      <FormItem prop="deliveryId" label="快递单号">
        <Input v-model="form.deliveryId" placeholder="请输入快递单号" maxlength="20" />
      </FormItem>
      <div>
        <FormItem prop="detail" label="发票图片或pdf" style="width:950px;">
          <Upload            
            v-model="imgUrl"
            accept=".pdf,.png,.jpg"
            fileType=""
            :multiple="true"
            :showFileName="true"
            :maxFileSize="1024 * 50"
            :limit="50"
            @change="changeUpload"
            ref="upload"
          ></Upload>
        </FormItem>
      </div>

      <div class="tips-box">
        <div class="title">如开具发票：</div>
        <span>1、请根据申请金额开具服务费发票;</span>
        <span>2、发票填写：请根据开票信息，确保发票抬头、发票项目、发票金额准确无误（与本次提现金额保持一致）;</span>
        <span>3、我司将在收到发票以后进行转账;查看开票信息</span>
        <span>4、开票信息及注意事项请联系机构主管。</span>
      </div>
    </Form>
    <div class="ivu-modal-footer">
      <Button type="text" @click="visible = false">取消</Button>
      <Button type="primary" @click="ok" :loading="loading">确定</Button>
    </div>

    <changeMobile ref="changeMobile" @getUserNewMobile="getUserNewMobile"></changeMobile>
  </Modal>
</template>

<script>
import { codeTools } from '@/api/mixins';
import changeMobile from './changeMobile';
import Upload from '@/components/commons/Upload/index';

export default {
  mixins: [codeTools],
  components: { changeMobile, Upload },
  data() {
    return {
      visible: false,
      isEdit: false,
      isEditIdCard: false,
      form: {},
      bankList: [],
      title: '',
      loading: false,
      ids: [],
      money: null,
      canWithdraw: null,
      imgUrl: [],
      oldCard: ''
    };
  },
  methods: {
    async open(ids, money, canWithdraw) {
      this.imgUrl = [];
      this.ids = ids;
      this.money = money;
      this.canWithdraw = canWithdraw;
      this.title = `确认提现 (${money}元)`;
      this.isEdit = false;
      this.isEditIdCard = false;
      this.$notice.showLoading();
      await this.getUserCardInfo();
      await this.getBankList();
      this.visible = true;
      this.$notice.hideLoading();
      this.clearCodeTimer();
      this.form.detail = [];
    },
    // 获取用户银行信息
    getUserCardInfo() {
      this.$http({
        url: '/buz/userBase/read/userCardInfo',
        type: 'GET',
        data: {
          fuzz: false
        }
      }).then(res => {
        this.oldCard = res.data.cardNo;
        this.form = res.data;
        if (!this.form.cardNo) {
          this.isEdit = true;
        }
        if (!this.form.idNo) {
          this.isEditIdCard = true;
        }
      });
    },
    // 获取银行列表
    getBankList() {
      this.$http({
        url: '/system/dic/read/dicList',
        type: 'POST',
        data: {
          code: 'BANK_TYPE'
        }
      }).then(res => {
        this.bankList = res.data;
      });
    },
    changeCard() {
      if (!this.form.cardNo) {
        return;
      }
      this.$http({
        url: '/buz/userCertificate/queryBankByCardNo',
        type: 'GET',
        data: {
          cardNo: this.form.cardNo.replace(/\s*/g, '')
        }
      }).then(res => {
        if(!res.data) {
          this.form.bankCode = '';
        }
        this.bankList.map(item => {
          if (item.txt == res.data) {
            this.form.bankCode = item.value;
          }
        });
      });
    },
    changeUpload(data) {
      this.form.detail = data;
    },
    ok() {
      this.$refs.form.validate().then(async isok => {
        if (!isok) {
          return;
        }
        if (this.form.cardNo != this.oldCard) {
          this.$http({
            url: '/buz/userBase/updateUserCardInfo',
            type: 'POST',
            data: {
              bank: this.form.bankCode,
              cardNo: this.form.cardNo.replace(/\s*/g, ''),
              reservedMobile: this.form.mobile
            }
          }).then(res => {
            this.submit();
          });
        } else {
          this.submit();
        }
      });
    },
    submit() {
      let data = {
        settleNumbers: this.ids,
        availableAmount: this.canWithdraw,
        requestAmount: this.money,
        deliveryCompany: this.form.deliveryCompany,
        deliveryId: this.form.deliveryId,
        detail: this.form.detail
      };
      this.loading = true;
      this.$http({
        url: '/buz/userCashWithdrawLog/waitWithdrawalCreate',
        type: 'POST',
        data
      })
        .then(res => {
          this.$notice.success('提交成功');
          this.$emit('ok');
          this.visible = false;
        })
        .finally(res => {
          this.loading = false;
        });
    },
    // 绑定身份证
    bindIdCard() {
      const params = {
        idNo: this.form.idNo
      };
      return this.$http({
        url: '/buz/userBase/bindIdNo',
        type: 'post',
        data: params
      });
    },
    // 绑定银行卡
    bindBankCard() {
      const params = {
        bank: this.form.bankCode,
        cardNo: this.form.cardNo,
        code: this.form.code,
        reservedMobile: this.form.mobile
      };
      if (this.isEditIdCard) {
        params.idNo = this.form.idNo;
      }
      return this.$http({
        url: '/buz/userBase/bindBankCard',
        type: 'post',
        data: params
      });
    },
    // 获取新手机号
    getUserNewMobile(data) {
      this.form.mobile = data;
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/.ivu-modal-header {
  padding: 22px 26px 18px 22px !important;
  font-size: 18px !important;
  border-bottom: none !important;
}
.withdrawal-modal /deep/ {
  .tips {
    display: block;
    margin-top: 10px;
  }
  .code-btn {
    position: absolute;
    right: 10px;
    top: 0;
    bottom: 0;
    width: 80px;
    text-align: center;
    margin: auto;
    height: 30px;
    &.blue {
      color: #236dff;
      cursor: pointer;
    }
  }
}
.tips-box {
  display: flex;
  flex-direction: column;
  .title {
    margin-bottom: 5px;
    font-size: 15px;
  }
}
</style>
